<svelte:options accessors/>
<script lang="ts">
    import FormPlaca from "./FormPlaca.svelte";
    import {onMount} from "svelte";
    import {ManagerVehicles} from "../../models/manager-vehicles";

    export let data = []
    export let params;
    export let selected = '';
    let add: boolean = false;
    let form;
    let manager: ManagerVehicles;

    export function setLoading(params) {
        if (form) {
            form.loading = false;
            if (params) {
                add = false;
            }
        }
    }

    onMount(() => {
        manager = ManagerVehicles.getInstance();
        manager.vehicles$.subscribe((next)=>{
            data = next;
        });
    });
</script>
<div>
    {#if add}
        <FormPlaca on:cancel={()=>add=false}
                   on:validateVehicle
                   {params}
                   bind:this={form}/>
    {:else}
        <div class="mb-2">
            {#if data.length > 1}
                <p>Selecciona tu Nissan y encuentra todo lo que necesitas</p>
            {:else}
                <p>Ingresa tu número de placa o selecciona el modelo de tu vehículo y te mostraremos los productos
                    apropiados para tu NISSAN</p>
            {/if}
        </div>
        {#each data as vehicle}
            <div class="border p-1 box-l sx-1 mb-1" on:click={()=> manager.setSelected(vehicle)}>
                <div>
                    {#if vehicle.selected}
                        <div>
                            <img height="24" width="24" src="/static/storefront/pix/material/check_circle.svg" alt="Deseleccionar vehículo">
                        </div>
                    {:else}
                        <div>
                            <img height="24" width="24" src="/static/storefront/pix/material/circle.svg" alt="Seleccionar Vehículo">
                        </div>
                    {/if}
                </div>
                <div>
                    {#if vehicle.placa}
                        <p>{vehicle.placa} - {vehicle.descModeloTASA}</p>
                    {:else}
                        <p>{vehicle.descModeloTASA}</p>
                    {/if}
                </div>
            </div>
        {/each}
        <div class="box-r mt-15">
            <div class="view-more"
                 style="font-size: 15px"
                 on:click={()=>add=true}>
                Validar nuevo vehículo
            </div>
        </div>
        <div class="box mt-2">
            <div class="btn accent min-w-200px text-c">
                GUARDAR
            </div>
        </div>
    {/if}
</div>

<style>
    .cancel {
        font-size: 15px;
        color: var(--text);
    }
</style>